module.exports = __webpack_public_path__ + "static/media/tracy_09.da242206.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/album/tracy_09.jpg
// module id = 387
// module chunks = 0